import React from "react";

export const SteeringWheelIcon = () => {
  return (
    <svg
    width={40}
    height={40}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <g>
        <path
          style={{ fill: "#353640" }}
          d="M131.825,232.956l-25.552-33.415l-0.131,0.031c-17.058,4.267-32.377,9.244-45.536,14.799
		L31.561,237.7l24.909,27.964c14.324-3.542,29.453,0.566,42.629,10.227l-0.012-0.029c-0.001-0.007-0.001-0.015-0.002-0.022
		l0.015,0.05l0,0l0,0l0,0l0,0L131.825,232.956z"
        />
        <path
          style={{ fill: "#353640" }}
          d="M185.602,354.326l-50.332,6.697c-1.496,16.025-7.244,30.206-16.395,40.109l5.933,40.135
		l38.889-8.149c0,0,4.058-23.673,34.561-38.675L185.602,354.326z"
        />
        <path
          style={{ fill: "#353640" }}
          d="M380.176,232.956l25.552-33.415l0.131,0.031c17.058,4.267,32.377,9.244,45.536,14.799L480.44,237.7
		l-24.909,27.964c-14.324-3.542-29.453,0.566-42.629,10.227l0.012-0.029c0.001-0.007,0.001-0.015,0.002-0.022l-0.015,0.05l0,0l0,0
		l0,0l0,0L380.176,232.956z"
        />
        <path
          style={{ fill: "#353640" }}
          d="M326.4,354.326l50.332,6.697c1.496,16.025,7.244,30.206,16.395,40.109l-5.933,40.135l-38.889-8.149
		c0,0-4.058-23.673-34.561-38.675L326.4,354.326z"
        />
      </g>
      <g>
        <path
          style={{ fill: "#515262" }}
          d="M256.001,503.307c-66.058,0-128.162-25.725-174.873-72.434S8.694,322.058,8.694,256
		S34.418,127.838,81.128,81.127S189.942,8.693,256.001,8.693s128.162,25.725,174.873,72.434S503.308,189.942,503.308,256
		s-25.725,128.162-72.434,174.873S322.059,503.307,256.001,503.307z M256.001,56.236C145.85,56.236,56.237,145.85,56.237,256
		s89.614,199.764,199.764,199.764S455.764,366.15,455.764,256C455.764,145.849,366.15,56.236,256.001,56.236z"
        />
        <path
          style={{ fill: "#515262" }}
          d="M106.272,199.541c-0.027,0.066-12.837,31.324-7.187,76.322l0.012,0.029
		c14.109,10.345,25.977,27.061,32.191,47.646c3.879,12.853,5.084,25.67,3.981,37.485c0.001,0,27.157-1.827,62.989,33.42l0,0l0,0
		c18.031,4.329,37.473,6.689,57.742,6.689s39.711-2.36,57.742-6.689c35.832-35.246,62.989-33.42,62.989-33.42l0,0
		c-1.103-11.816,0.102-24.632,3.981-37.485c6.214-20.585,18.082-37.3,32.191-47.646l0.012-0.029
		c5.649-44.998-7.16-76.256-7.187-76.322c-41.563-10.389-93.443-16.563-149.729-16.563S147.835,189.152,106.272,199.541z"
        />
      </g>
      <circle
        style={{ fill: "#353640" }}
        cx="256.006"
        cy="256.006"
        r="31.539"
      />
      <path
        d="M256.001,296.235c22.186,0,40.235-18.049,40.235-40.235c0-22.186-18.049-40.235-40.235-40.235S215.766,233.814,215.766,256
	C215.766,278.186,233.815,296.235,256.001,296.235z M256.001,233.151c12.599,0,22.849,10.25,22.849,22.849
	c0,12.599-10.25,22.849-22.849,22.849s-22.849-10.25-22.849-22.849C233.152,243.401,243.401,233.151,256.001,233.151z"
      />
      <path
        d="M256.001,512c35.425,0,69.675-7.06,101.798-20.983c4.406-1.909,6.428-7.027,4.519-11.433
	c-1.909-4.405-7.027-6.431-11.433-4.519c-29.929,12.971-61.853,19.549-94.885,19.549c-63.735,0-123.658-24.821-168.725-69.888
	S17.387,319.735,17.387,256c0-59.338,21.868-116.157,61.576-159.99c3.223-3.558,2.951-9.056-0.606-12.279
	c-3.558-3.223-9.056-2.952-12.279,0.606C23.467,131.375,0.001,192.339,0.001,256c0,68.38,26.629,132.667,74.981,181.019
	S187.621,512,256.001,512z"
      />
      <path
        d="M256.001,0C195.523,0,136.904,21.421,90.942,60.315c-3.665,3.102-4.122,8.586-1.02,12.251
	c3.101,3.666,8.586,4.123,12.251,1.02c42.827-36.241,97.457-56.2,153.827-56.2c63.737,0,123.658,24.821,168.725,69.888
	c45.068,45.068,69.889,104.989,69.889,168.725s-24.82,123.658-69.889,168.725c-12.956,12.956-27.35,24.407-42.783,34.034
	c-4.073,2.541-5.316,7.904-2.775,11.977c1.648,2.643,4.483,4.093,7.384,4.093c1.571,0,3.162-0.427,4.592-1.319
	c16.552-10.326,31.986-22.603,45.874-36.491c48.352-48.352,74.981-112.639,74.981-181.019s-26.628-132.665-74.98-181.017
	S324.38,0,256.001,0z"
      />
      <path
        d="M256.001,64.929c43.719,0,84.899,14.443,119.086,41.771c3.75,2.997,9.22,2.388,12.218-1.363
	c2.997-3.75,2.388-9.22-1.363-12.218c-36.768-29.39-82.916-45.576-129.941-45.576c-100.035,0-183.826,70.834-203.882,164.976
	c-0.019,0.085-0.039,0.169-0.056,0.254c-2.953,13.951-4.519,28.409-4.519,43.227c0,3.299,0.086,6.579,0.239,9.841
	c0.002,0.107,0.006,0.212,0.012,0.318c2.676,55.499,27.158,105.37,65.043,141.218c0.048,0.046,0.089,0.096,0.138,0.141
	c0.044,0.041,0.092,0.074,0.136,0.114c13.669,12.889,29.075,23.949,45.825,32.8c0.449,0.297,0.931,0.549,1.437,0.759
	c28.658,14.859,61.179,23.266,95.627,23.266c34.681,0,67.404-8.524,96.202-23.57c0.049-0.024,0.095-0.05,0.144-0.075
	c17.028-8.913,32.679-20.108,46.544-33.18c0.045-0.039,0.093-0.073,0.137-0.115c0.049-0.045,0.09-0.095,0.138-0.14
	c37.882-35.847,62.363-85.713,65.042-141.207c0.007-0.112,0.01-0.225,0.013-0.338c0.152-3.259,0.239-6.535,0.239-9.83
	c0-14.454-1.508-28.759-4.436-42.711c-0.067-0.525-0.178-1.041-0.338-1.543c-7.51-34.479-23.721-66.737-47.463-93.611
	c-3.179-3.598-8.672-3.937-12.27-0.759c-3.598,3.179-3.937,8.672-0.759,12.27c18.228,20.632,31.616,44.724,39.53,70.573
	c-47.57-16.571-112.901-25.936-182.722-25.936c-69.84,0-135.189,9.37-182.761,25.951C97.158,121.998,170.035,64.929,256.001,64.929z
	 M159.024,420.568c-10.056-5.948-19.527-12.783-28.294-20.411c5.831-8.458,9.852-18.59,11.933-29.621
	c2.439,0.504,5.452,1.309,8.965,2.608c7.611,2.815,18.857,8.476,32.047,19.722C170.053,402.067,162.8,412.74,159.024,420.568z
	 M256.001,447.071c-29.2,0-56.885-6.593-81.661-18.354c2.956-6.429,9.802-16.832,25.059-25.082
	c18.193,4.109,37.218,6.191,56.601,6.191c19.384,0,38.408-2.082,56.602-6.191c15.255,8.248,22.104,18.652,25.059,25.081
	C312.886,440.477,285.2,447.071,256.001,447.071z M352.977,420.568c-3.776-7.828-11.03-18.5-24.652-27.703
	c13.19-11.245,24.437-16.906,32.047-19.722c3.513-1.299,6.527-2.104,8.965-2.608c2.079,11.032,6.101,21.165,11.933,29.623
	C372.504,407.785,363.033,414.62,352.977,420.568z M443.754,220.634c2.173,11.51,3.299,23.263,3.314,35.127
	c-8.156-0.305-16.324,1.285-24.161,4.516c0.788-20.364-1.799-37.065-4.423-48.308C427.477,214.623,435.933,217.513,443.754,220.634z
	 M446.295,273.127c-3.959,44.351-23.125,84.391-52.248,114.843c-9.808-15.952-11.876-39.179-5.012-61.92
	C398.556,294.503,423.162,272.409,446.295,273.127z M112.954,206.801c40.936-9.768,90.596-15.129,143.047-15.129
	s102.11,5.362,143.047,15.129c2.858,9.087,8.934,33.052,5.651,64.415c-14.247,11.526-25.978,28.839-32.308,49.81
	c-3.242,10.742-4.771,21.647-4.7,32.156c-11.759,2.115-33.173,9.334-58.212,33.31c-17.153,3.933-35.126,5.947-53.476,5.947
	c-18.351,0-36.323-2.016-53.476-5.948c-25.04-23.977-46.454-31.195-58.212-33.311c0.071-10.508-1.458-21.413-4.7-32.154
	c-6.33-20.971-18.06-38.284-32.307-49.809C104.02,239.852,110.096,215.888,112.954,206.801z M122.966,326.05
	c6.864,22.741,4.796,45.968-5.012,61.92c-29.123-30.451-48.29-70.492-52.248-114.843C88.836,272.414,113.444,294.502,122.966,326.05
	z M93.517,211.968c-2.624,11.244-5.212,27.945-4.423,48.308c-7.835-3.23-16.003-4.821-24.161-4.516
	c0.015-11.995,1.15-23.731,3.289-35.117C76.05,217.52,84.514,214.626,93.517,211.968z"
      />
    </svg>
  );
};

export default SteeringWheelIcon;
